<template>
  <div class="mobile-share">
    <Form inline>
      <FormItem>
        <Button type="primary"
                @click="onAdd">新建模板</Button>
      </FormItem>
    </Form>
    <Grid ref="grid"
          data-url="/api/shareSetting"
          :columns="tableColumns"
          :search="searchCondition"
          :rowsFormatter="onrowsFormatter"
          selectType
          keyField="id"
          method="get">
      <template slot-scope="{row}"
                slot="c1">
        <div class="vmiddle"
             style="padding:5px 0;">
          <img :src="row.img"
               alt="模板图片"
               style="height:100px;" />
        </div>
      </template>
      <template slot-scope="{row}"
                slot="c2">
        <div class="vmiddle"
             style="padding:5px 0;">
          <span v-if="row.type==1">课程</span>
          <span v-if="row.type==2">章节练习</span>
          <span v-if="row.type==3">模拟考试</span>
        </div>
      </template>
      <template slot-scope="{row}"
                slot="action">
        <Button type="text"
                @click="onEdit(row)">编辑</Button>
        <span>-</span>
        <Button type="text"
                @click="onDelete(row)">删除</Button>
      </template>
    </Grid>
    <Modal v-model="modal.show"
           :title="modal.title">
      <Form ref="modalForm"
            :model="modal.form"
            :rules="modal.formRules"
            :label-width="110">
        <FormItem label="上传图片模板："
                  prop="img">
          <div class="upload-avatar-box">
            <div class="avatar"
                 v-show="modal.form.img">
              <img :src="modal.form.img" />
            </div>
            <UploadFile url="/api/public/img"
                        :format="['jpg','jpeg','png']"
                        :primary="false"
                        note="*分享时会在图片右下角自动生成分享二维码，支持jpg、jpeg、png，宽高：690*990像素"
                        @onSuccess="onUploadSuccess"></UploadFile>
          </div>
        </FormItem>
        <FormItem label="排序号："
                  prop="sort">
          <InputNumber v-model="modal.form.sort"
                       style="width:100px;"></InputNumber>
        </FormItem>
        <FormItem label="类型："
                  prop="type">
          <Select v-model="modal.form.type"
                  style="width:100px;"
                  placeholder="请选择">
            <Option label="课程"
                    value="1">课程</Option>
            <Option label="章节练习"
                    value="2">章节练习</Option>
            <Option label="模拟考试"
                    value="3">模拟考试</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary"
                @click="onOkModal">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import UploadFile from "@/components/UploadFile";
export default {
  name: "mobile-share",
  components: {
    UploadFile
  },
  data () {
    return {
      tableColumns: [
        { title: "排序号", key: "sort", align: "center", minWidth: 90 },
        { title: "图片", slot: "c1", align: "center", minWidth: 150 },
        {
          title: "类型",
          slot: "c2",
          align: "center",
          minWidth: 150
        },
        {
          title: "发布人",
          key: "creator_name",
          align: "center",
          minWidth: 150
        },
        {
          title: "创建时间",
          key: "created_time",
          align: "center",
          minWidth: 150
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 150,
          fixed: "right"
        }
      ],
      searchCondition: {},
      modal: {
        show: false,
        title: "",
        type: "", // add 或 edit
        id: "",
        form: {
          img: "",
          sort: 1,
          init () {
            this.img = "";
            this.sort = 1;
          }
        },
        formRules: {
          img: [{ required: true, message: "请上传图片模板" }],
          type: [
            { required: true, message: '请选择类型', trigger: 'change' }
          ],
          sort: [
            {
              type: "number",
              required: true,
              message: "请填写排序号",
              trigger: "blur"
            }
          ]
        }
      }
    };
  },
  created () { },
  methods: {
    // on event
    onAdd () {
      if (this.$refs.grid.getTotal() >= 8) {
        this.$Message.info("最多只能有8个分享模板");
        return;
      }
      this.modal.show = true;
      this.modal.title = "新建模板";
      this.modal.type = "add";
      this.modal.form.init();
    },
    onEdit (row) {
      this.modal.show = true;
      this.modal.title = "编辑模板";
      this.modal.type = "edit";
      this.modal.id = row.id;
      this.modal.form.img = row.img;
      this.modal.form.sort = row.sort;
    },
    onDelete (row) {
      this.$Modal.confirm({
        title: "提示",
        content: "确认删除么？",
        cancelText: "再想想",
        okText: "删除",
        onOk: () => {
          this.$http.delete(`/api/shareSetting/${row.id}`).then(() => {
            this.$Message.success("删除成功");
            this.$refs.grid.searchRefresh();
          });
        }
      });
    },
    onrowsFormatter (rows) {
      rows.forEach(i => {
        i.created_time = this.$pub.timestampToTime(i.created_at);
      });
    },
    onUploadSuccess (data) {
      this.modal.form.img = data.path;
    },
    onOkModal () {
      this.$refs.modalForm.validate(valid => {
        if (!valid) return;
        if (this.modal.type == "add") {
          this.$http.post("/api/shareSetting", this.modal.form).then(() => {
            this.$Message.success("添加成功");
            this.$refs.grid.searchRefresh();
            this.modal.show = false;
          });
        } else if (this.modal.type == "edit") {
          this.$http
            .put(`/api/shareSetting/${this.modal.id}`, this.modal.form)
            .then(() => {
              this.$Message.success("编辑成功");
              this.$refs.grid.searchRefresh();
              this.modal.show = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>